import React from 'react';
import './MaintenanceNotice.css';
import STC from '../../../STCLibrary/STCFactory/STCFactory';

export default function MaintenanceNotice({maintenanceData}) {
    return (
        <div className='maintenance-page'>
            <div className='maintenance-notice-container'>
                <div className='logo-line'><STC.Logo.Bordered/></div>
                
                <h1>{maintenanceData.main_text}</h1>
                <h4>{maintenanceData.secondary_text}</h4>
            </div>
        </div>
    );
}
